import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface TableHeaderProps {
  children: ReactNode
  isNested?: boolean
  nestedRow?: ReactNode
}

export const TableHeader = ({ children, isNested, nestedRow }: TableHeaderProps) => {
  const { t } = useTranslation()

  return (
    <Styled.TableHeader>
      <tr>
        <Styled.HeaderCell rowSpan={isNested ? 2 : 1}>{t('account')}</Styled.HeaderCell>
        {children}
      </tr>
      {nestedRow}
    </Styled.TableHeader>
  )
}
